import { setSelectedLocation } from "components";
import { DealersAndLocationsDropdownKeys } from "components/DealersAndLocationsDropdown/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocation } from "models";

export const useUpdateLocationMutation = () =>
  useTypedMutation<DealerLocation, void>({
    mutationFn: async payload => (await ApiInstance.post("/locations/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const updatedLocation = {
        ...payload,
        dbb_enabled: payload.active && payload.dbb_enabled,
        is_exact_invoicing_enabled: payload.active && payload.is_exact_invoicing_enabled
      };

      const dealers = typedQueryClient.getQueryData(DealersDashboardQueryKeys.list);
      const listDealerIdx = dealers?.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealers && listDealerIdx !== -1) {
        const listDealer = dealers[listDealerIdx];
        const listLocationIdx = listDealer.locations?.findIndex(location => location.id === payload.id) ?? -1;

        if (listDealer.locations && listLocationIdx !== -1)
          typedQueryClient.setQueryData(
            DealersDashboardQueryKeys.list,
            dealers.with(listDealerIdx, {
              ...listDealer,
              locations: listDealer.locations.with(listLocationIdx, { ...listDealer.locations[listLocationIdx], ...updatedLocation })
            })
          );
      }

      typedQueryClient.invalidateQueries(DealersDashboardQueryKeys.locationDetails(payload.id));

      const dealersList = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.dealers);
      const dealerIdx = dealersList?.dealers.findIndex(dealer => dealer.id === payload.dealer_id) ?? -1;

      if (dealersList && dealerIdx !== -1) {
        const dealer = dealersList.dealers[dealerIdx];
        const locationIdx = dealer.locations?.findIndex(location => location.id === payload.id) ?? -1;

        if (dealer.locations && locationIdx !== -1)
          typedQueryClient.setQueryData(DealersAndLocationsDropdownKeys.dealers, {
            ...dealersList,
            dealers: dealersList.dealers.with(dealerIdx, {
              ...dealer,
              locations: dealer.locations.with(locationIdx, { ...dealer.locations[locationIdx], ...updatedLocation })
            })
          });
      }

      const selectedLocation = typedQueryClient.getQueryData(DealersAndLocationsDropdownKeys.selectedLocation);
      if (selectedLocation?.id !== payload.id) return;

      setSelectedLocation({ ...selectedLocation, ...updatedLocation });
    }
  });
